var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: ["day-usage-panel", ..._setup.classList],
      attrs: { id: _setup.dateKey },
    },
    [
      _c(
        "div",
        { staticClass: "panel-content-top" },
        [
          _setup.dataType
            ? _c(_setup.UsageTypeEmblem, {
                attrs: { type: _setup.dataType, text: false },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-content-bottom" }, [
        !_setup.dataType
          ? _c("small", { staticClass: "no-usage-text" }, [
              _vm._v(" No usage data "),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }